import {CRISPRVector} from 'constants/CRISPRConstants';
import * as net from 'util/Net';

export interface CreateVectorData {
  sequence: string; // This is actually the sequence's API ID
  insertionRegionStart: number;
  insertionRegionEnd: number;
}
export function create(data: CreateVectorData): JQueryPromise<CRISPRVector> {
  return net.postJSON({url: '/1/api/crispr-vectors/', data});
}

export function getAll(): JQueryPromise<{data: Array<CRISPRVector>}> {
  return net.getJSON('/1/api/crispr-vectors/');
}

export function update(id: string, data: {}): JQueryPromise<CRISPRVector> {
  return net.patchJSON({url: `/1/api/crispr-vectors/${id}`, data});
}
